// @flow
export const ProductIdsMap = {
    platform: 'platform',
    trackIQ: 'motiontrack',
    dispatchIQ: 'dispatcher',
    orderIQ: 'orderiq',
    shipflex: 'orchestration'
};

export type Product = $Keys<typeof ProductIdsMap>;

export const toApiProduct = (product: string): string => {
    return ProductIdsMap[product] ?? product;
};

export const toTranslationKey = (product: string, key: string): string => {
    return `settings.${product}.fields.${key}`;
};
